import { DOCUMENT } from '@angular/common';
import { Component, OnInit,Inject, ViewChild, ElementRef } from '@angular/core';
import { HomepageService } from '../../services/homepage.service';
import { AuthService } from '../../services/auth.service';
import { CookieService } from 'ngx-cookie-service';
import { UserIdleService } from 'angular-user-idle';
import { NavigationEnd, Router} from '@angular/router';
import { NotifierService } from 'angular-notifier';
import { environment } from '../../../environments/environment';


@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit {
  auth2: any;
  @ViewChild('loginRef') loginElement: ElementRef;
  private readonly notifier: NotifierService;
	constructor( notifierService: NotifierService, private router: Router,private homepageService: HomepageService,@Inject(DOCUMENT) private document: Document, private authService: AuthService, private cookieService: CookieService,private userIdle: UserIdleService ) {
    this.notifier = notifierService;

    this.authService.logoutObservable$.subscribe(loggedOut => {
      if(loggedOut){

      }
    });
  }

	gloalSetting: any = [];
  loginPlaceHolder: string = '';
  checkLogin: boolean = false;
  selectedResourcesIds: any = [];
  forgotPassword: boolean = false;
  requiredChange:boolean = false;
  isNonComplaint:boolean = false;
  passwordRequirement: any = null;
  checkPassword: boolean = false;
  patronLoggedIn:boolean = false;
  shareLinkEditors: boolean = false;
  linksEditors: boolean = false;
  contactEditor: boolean = false;
  updatingEmail: boolean = false;
  emailUpdateRes:boolean = false;
  emailUpdateResMail:boolean = false;
  years: number = new Date().getFullYear();
  requirePassword:boolean = false;
  count = 60;
  firstName: string ='';
  ngOnInit() {
    if(this.cookieService.check('patron')){
      this.patronLoggedIn = true;
    }
    if(localStorage.getItem("token")){
       this.patronLoggedIn = true;
    }
     let profile = JSON.parse(localStorage.getItem('info'));
     if(profile){
      this.firstName = profile.detail.firstName;
     }
    if(localStorage.getItem("requireChange") === null || localStorage.getItem("token") === null) {
      }else{
        if(localStorage.getItem("isNonComplaint") === null){
          this.isNonComplaint = false;
        }else{
          this.isNonComplaint = true;
        }
        this.requiredChange = true;
        this.authService.getPasswordRequirement(localStorage.getItem('token')).subscribe(passwordReq => {
          this.passwordRequirement = passwordReq;
        },(passwordErr) =>{
          this.requiredChange = true;
        });
    }
  	this.gloalSetting = this.homepageService.getUpdatedConfig();
    if(this.gloalSetting.data.settings.patron.login.facebook)
    this.fbLibrary();
    if(this.gloalSetting.data.settings.patron.login.loginWithName){
      if(this.gloalSetting.data.settings.patron.login.loginWithMail)
        this.loginPlaceHolder = "Patron number, Email or Name";
      else
        this.loginPlaceHolder = "Patron number or Name";
    } else {
      if(this.gloalSetting.data.settings.patron.login.loginWithMail)
        this.loginPlaceHolder = "Patron number or Email";
      else
        this.loginPlaceHolder = "Patron number";
    }
    this.userIdle.stopWatching();

    // Configuration for userIdle
    this.userIdle.setConfigValues({
      idle: (this.gloalSetting.data.settings.timeout.minutes) * 60,
      timeout: 60,
      ping: 60
    });

    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        // Only run this check once, on the first navigation
        if (!window['__idleChecked']) {
          window['__idleChecked'] = true;
          const lastActiveTime = localStorage.getItem('lastActiveTime');
          if (lastActiveTime) {
            const now = Date.now();
            const idleTime = this.gloalSetting.data.settings.timeout.minutes * 60 * 1000;
            if (now - parseInt(lastActiveTime, 10) > idleTime) {
              this.handleTimeout();
            }
          }
        }
      }
    });

    // Start watching for idle time
    this.userIdle.startWatching();

    // Update last active time on user activity
    this.updateLastActiveTime();

    // Add event listeners for user activity
    ['mousemove', 'keydown', 'click', 'scroll'].forEach(event => {
      document.addEventListener(event, (event)=> {this.updateLastActiveTime()});
    });

    this.userIdle.onTimerStart().subscribe(count => {
      let homeLink = $('#navbarid a[href="/"]');
      let homePageBoolean = ((this.cookieService.check('patron') ||
       this.cookieService.check('recentSearch') ||
        localStorage.getItem('selectedResourcesIds') !== null ||
         localStorage.getItem('token') !== null) && (homeLink.text().trim() === 'Home' && homeLink.hasClass('active'))  );
         let otherPageBoolean = (homeLink.text().trim() === 'Home' && !homeLink.hasClass('active'));

         this.count--;
      if (count === 1 && this.gloalSetting.data.settings.timeout.enabled && (homePageBoolean || otherPageBoolean)) {
        $('#ruthere').fadeIn('slow');
      }
    });

    this.userIdle.onTimeout().subscribe(() => {
      this.handleTimeout();
    });
  }
  handleTimeout() {
    if (this.gloalSetting.data.settings.timeout.enabled) {
      this.logout();
    }
  }

  logout(){
    $('#ruthere').fadeOut();
      $('body').find('#myCollectionLi').find('.my-list-count').text('0');
      $('body').find('#profileLi').removeClass('show').addClass('hide');
      $('body').find('#loginLi').removeClass('hide').addClass('show');
      $('.widgets.select-box').css('min-height', 'auto');
      $('.SearchResults').find('.count').text('0');
      localStorage.removeItem('info');
      this.homepageService.updateIsLogin(false);
      this.cookieService.deleteAll('/');
      this.document.body.classList.remove('login-patron');
      this.document.body.classList.remove('manage-view');
      localStorage.removeItem('selectedResourcesIds');
      localStorage.removeItem('token');
      localStorage.removeItem('requireChange');
      localStorage.removeItem('isNonComplaint');
      localStorage.removeItem('Session-Id');
      this.patronLoggedIn = false;
      this.requirePassword = false;
      this.userIdle.resetTimer();
      this.userIdle.stopWatching();
      this.userIdle.setConfigValues({
        idle: (this.gloalSetting.data.settings.timeout.minutes) * 60,
        timeout: 60,
        ping: 60
      });
      this.updateLastActiveTime();
      this.userIdle.startWatching();
      this.count = 60;
      this.router.navigate(['/']);
  }
  updateLastActiveTime() {
    localStorage.setItem('lastActiveTime', Date.now().toString());
  };
  login() {
    if(window['FB']){
      window['FB'].login((response) => {
          //console.log('login response',response);
          if (response.authResponse) {
            this.authService.authFacebook(response.authResponse.accessToken).subscribe(data => {
              var locationId = this.homepageService.getLocationId();
              localStorage.setItem('token', data.access_token);
              localStorage.setItem('refreshToken', data.refresh_token);
              if( localStorage.getItem('selectedResourcesIds') != null ) {
                this.selectedResourcesIds = JSON.parse(localStorage.getItem('selectedResourcesIds'));
                this.homepageService.saveMyList(data.access_token,this.selectedResourcesIds).subscribe(addTempIds => {
                  this.cookieService.delete('tempPersonalCollection');
                  this.getProfileDetail(data.access_token,locationId);
                 });
              } else {
                this.getProfileDetail(data.access_token,locationId);
              }
            },(err) =>{
               this.checkLogin = false;
            });
          } else {
            //console.log('User login failed');
          }
      }, {scope: 'email'});
    }else{
      //console.log('You are using private/incognito window, please use normal one');
    }

  }

  fbLibrary() {
    (window as any).fbAsyncInit = function() {
      window['FB'].init({
        appId      : '203418504446263',
        cookie     : true,
        xfbml      : true,
        version    : 'v3.1'
      });
      window['FB'].AppEvents.logPageView();
    };
    (function(d, s, id){
       var js, fjs = d.getElementsByTagName(s)[0];
       if (d.getElementById(id)) {return;}
       js = d.createElement(s); js.id = id;
       js.src = "https://connect.facebook.net/en_US/sdk.js";
       fjs.parentNode.insertBefore(js, fjs);
     }(document, 'script', 'facebook-jssdk'));
  }

  //loading goodle sdk for goodle login.
  googleSDK() {
    window['googleSDKLoaded'] = () => {
      window['gapi'].load('auth2', () => {
        this.auth2 = window['gapi'].auth2.init({
          client_id: '1003925052394-fllpkk5hbvna7i5hif1hcimh08tqsatv.apps.googleusercontent.com',
          cookiepolicy: 'single_host_origin',
          scope: 'profile email'
        });
        this.prepareLoginButton();
      });
    }
    (function(d, s, id){
      var js, fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) {return;}
      js = d.createElement(s); js.id = id;
      js.src = "https://apis.google.com/js/platform.js?onload=googleSDKLoaded";
      fjs.parentNode.insertBefore(js, fjs);
    }(document, 'script', 'google-jssdk'));
  }

  //This will prepare google login button.
  prepareLoginButton() {
    //console.log('prepare login button');
    this.auth2.attachClickHandler(this.loginElement.nativeElement, {},
    (googleUser) => {
      //YOUR CODE HERE
      this.authService.authGoogle(googleUser.getAuthResponse().access_token).subscribe(data => {
        var locationId = this.homepageService.getLocationId();
        localStorage.setItem('token', data.access_token);
        if( localStorage.getItem('selectedResourcesIds') != null ) {
          this.selectedResourcesIds = JSON.parse(localStorage.getItem('selectedResourcesIds'));
          this.homepageService.saveMyList(data.access_token,this.selectedResourcesIds).subscribe(addTempIds => {
            this.cookieService.delete('tempPersonalCollection');
            this.getProfileDetail(data.access_token,locationId);
           });
        } else {
          this.getProfileDetail(data.access_token,locationId);
        }
      },(err) =>{
         this.checkLogin = false;
      });

    }, (error) => {
      //console.log(error);
    });

  }

  //This will reset the idle timer, if user click any button.
  resetTimmer(){
    this.userIdle.resetTimer();
    $('#ruthere').fadeOut();
  }

 	//This will authenticate the user
  authentication(){
    //console.log("authentication");
    var username = $.trim($('#login-email').val().toString());
    if(username == ''){
      $('#login-email').addClass('error');
    }
    if(!this.gloalSetting.data.settings.patron.login.nonAdminRequiredPassword && !this.requirePassword){
      var password = username;
    }else{
      var password = $.trim($('#login-password').val().toString());
      if(password == ''){
        $('#login-password').addClass('error');
      }
    }
    if(username != '' && password!= '') {
      //console.log("username !=''");
      this.checkLogin = true;
      this.authService.authentication(username,password).subscribe(data => {
        this.requirePassword = false;
        //console.log(data.access_token +'=access token');
        var locationId = this.homepageService.getLocationId();
        localStorage.setItem('token', data.access_token);
        localStorage.setItem('refreshToken', data.refresh_token);
        this.cookieService.set("authorization", data.access_token);
        //this.homepageService.getAuthorization(data.access_token);
        if( localStorage.getItem('selectedResourcesIds') != null ) {
          this.selectedResourcesIds = JSON.parse(localStorage.getItem('selectedResourcesIds'));
          this.homepageService.saveMyList(data.access_token,this.selectedResourcesIds).subscribe(addTempIds => {
            this.cookieService.delete('tempPersonalCollection');
            this.getProfileDetail(data.access_token,locationId);
            if(data.requirePasswordReset){
              this.requiredChange = true;
              localStorage.setItem('requireChange', 'true');
              if(data.isNonComplaint){
                this.isNonComplaint = true;
                localStorage.setItem('isNonComplaint', 'true');
              }
              this.authService.getPasswordRequirement(data.access_token).subscribe(passwordReq => {
                this.passwordRequirement = passwordReq;
              },(passwordErr) =>{
                $('#passwordForce-modal').removeClass('show');
              });
            }
           });
        } else {
          this.getProfileDetail(data.access_token,locationId);
          if(data.requirePasswordReset){
            this.requiredChange = true;
            localStorage.setItem('requireChange', 'true');
            if(data.isNonComplaint){
              this.isNonComplaint = true;
              localStorage.setItem('isNonComplaint', 'true');
            }
            this.authService.getPasswordRequirement(data.access_token).subscribe(passwordReq => {
              this.passwordRequirement = passwordReq;
            },(passwordErr) =>{
              //$('#passwordForce-modal').removeClass('show');
            });
          }
        }
        //window.location.reload();
      },(err) =>{
        if(err.error.isPasswordRequired){
          if(!this.gloalSetting.data.settings.patron.login.nonAdminRequiredPassword && !this.requirePassword){
            $('#loginError').text("Password is required. Please enter the password.");
            $('#loginDotts').addClass('hide').removeClass('show');
          }else{
            $('#loginError').text(err.error.error_description.replace(/_/g, ' '));
            $('#loginDotts').addClass('hide').removeClass('show');
          }
          this.requirePassword = true;
          $('#login-password').val('');
          setTimeout(function(){
            $('#login-password').focus();
          },100);

        }else{
          if(err.error.error_description)
          $('#loginError').text(err.error.error_description.replace(/_/g, ' '));
          $('#loginDotts').addClass('hide').removeClass('show');
        }
        this.checkLogin = false;
      });

    }
    setTimeout(function(){
      $('#loginError').text('');
    },4000);
	}

  //This will show the forget password options to user.
  toggleForgot(){
    if(this.forgotPassword === false){
      this.forgotPassword = true;
    } else {
      this.forgotPassword = false;
    }
  }

  //This will send the forget request to server.
  forgotEmail(){
    $('#login-modal').find('.message').remove();
    var username = $.trim($('#forgot-email').val().toString());
     if(username == ''){
        $('#forgot-email').addClass('error');
        return;
      } else {
        this.checkLogin = true;
        this.authService.forgotPassword(username).subscribe( (data:any) => {
           this.checkLogin = false;
           var thisT = this;
           if(data.status.toString() === 'true'){
            $('#forgot-email').val('').parents('.form-group').before('<span class="message success">'+data.message.toString()+'</span>');
              setTimeout(function(){
                thisT.toggleForgot();
                $('#login-modal').find('#closelogin').trigger('click');
                $('#login-modal').find('#closelogin').click();
              },10000);
           } else {
            $('#forgot-email').parents('.form-group').before('<span class="message  error">'+data.message+'</span>');
           }

        },(error) => {
          $('#forgot-email').parents('.form-group').before('<span class="message  error">'+error.error.errorDescription+'</span>');
        });
      }
  }

  //This is key generated event, which trigger authentication.
  loginSubmit(event){
     if(event.key == 'Enter' && event.keyCode ==13){
       this.authentication();

     }
  }

  //This will send the update password request to server.
  updatePassword(event){
    setTimeout(function(){
        $('#change-password-modal').find('span.message').remove();
        $('#newpassword-email,#oldpassword-email,#confirmpassword-email').removeClass('error');
    },7000);
    $('#newpassword-email').removeClass('error');
    var oldPass = $.trim($('#oldpassword-email').val().toString());
     if(oldPass == ''){
      $('#oldpassword-email').addClass('error');
      return false;
    }
    var newPass = $.trim($('#newpassword-email').val().toString());
    if(newPass == ''){
      $('#newpassword-email').addClass('error');
      return false;
    }
    var confirmPass = $.trim($('#confirmpassword-email').val().toString());
    if(confirmPass == ''){
      $('#confirmpassword-email').addClass('error');
      return false;
    } else if(newPass !== confirmPass) {
       $('#confirmpassword-email').addClass('error');
       $('#confirmpassword-email').parents('.form-group').after('<span class="message error">The two new passwords you entered do not match.</span>');
      return false;
    }
    this.checkPassword = true;
    var token =  localStorage.getItem('token');
    this.authService.updatePassword(newPass,oldPass, token).subscribe(data => {
      this.checkPassword = false;
      $('#newpassword-email').val('');
      $('#oldpassword-email').parents('.form-group').before('<span class="success message">Your password changed successfully</span>');
      $('#change-password-modal').find('.form-group').find('input').val('')
     setTimeout(function(){
        $('#change-password-modal').find('#closelogin').trigger('click');
      },1000);
    },(err) => {
      if(err.status == 500){
        $('#oldpassword-email').parents('.form-group').before('<span class="error message">'+err.error.Message+'</span>');
         $('#oldpassword-email').addClass('error');
      }
      if(err.status == 400){
        $('#newpassword-email').parents('.form-group').before('<span class="error message">'+err.error.errors.Password[0]+'</span>');
         $('#newpassword-email').addClass('error');
      }
      this.checkPassword = false;
    });

  }

  //Submit changes for passwords
  changeSubmit(event){
    $('#loginErrorPass').html('');
    var error = false;
    var password = $("#change-password").val().toString();
    var passwordC = $("#changeConfirm-password").val().toString();
    if(this.passwordRequirement){
      if(this.passwordRequirement.data.minimumLength){
        if($.trim(password).length < this.passwordRequirement.data.minimumLength ){
          error=true;
          $('#loginErrorPass').append("<li class='text-danger'>Password length atleast "+this.passwordRequirement.data.minimumLength+" characters</li>");
          return false;
        }
      }
      if(this.passwordRequirement.data.mixedCase){
        if( !$.trim(password).match(/[A-Z]/) || !$.trim(password).match(/[a-z]/)){
          error=true;
          $('#loginErrorPass').append("<li class='text-danger'>Password must contains one uppercase and one lowercase characters</li>");
          return false;
        }
      }
      if(this.passwordRequirement.data.digitsLetterCombination){
        if( !$.trim(password).match(/[A-Za-z]/) || !$.trim(password).match(/[0-9]/)) {
          error=true;
          $('#loginErrorPass').append("<li class='text-danger'>Password must contain atleast one digit and one character</li>");
          return false;
        }
      }
      if(this.passwordRequirement.data.nonAlphanumeric){
        var format = /[ `!@#$%^&*()_+\-=\[\]{};:\\|,.<>\/?~]/;
        if(!format.test($.trim(password))){
          error=true;
          $('#loginErrorPass').append("<li class='text-danger'>Password must contain atleast one special character</li>");
          return false;
        }
      }
    }
    if(password != passwordC){
      error=true;
      $('#loginErrorPass').append("<li class='text-danger'>Confirm Password didn't match</li>");
      return false;
    }
    //console.log(error);
    if(error == false){
      $('button.submit-btn').removeAttr('disabled');
    }else{
      $('button.submit-btn').attr('disabled', 'disabled');
      return false;
    }
    //small latters
    if(event.key == 'Enter' && event.keyCode ==13 ){
       this.changePassword();
    }
  }

  changePassword(){
    var password = $.trim($('#change-password').val().toString());
    var passwordC = $.trim($("#changeConfirm-password").val().toString());
    if(password == '' && password != passwordC){
      return false;
    }
    this.checkLogin = true;
    var locationId = this.homepageService.getLocationId();
    var auth = localStorage.getItem('token');
    this.authService.resetTempPassword(password, locationId, auth).subscribe((data:any) => {
      if(data.status){
        this.requiredChange = false;
        this.isNonComplaint = false;
        this.checkLogin = false;
        this.notifier.notify( 'success', data.message );
        localStorage.removeItem('requireChange');
        localStorage.removeItem('isNonComplaint');
      } else {
        this.notifier.notify( 'error', "Something went wrong!" );
        this.requiredChange = false;
        this.isNonComplaint = false;
        this.checkLogin = false;
        localStorage.removeItem('requireChange');
        localStorage.removeItem('isNonComplaint');
      }
    });

    setTimeout(function(){
      $('#loginError').text('');
    },4000);
  }

//share link editor open
shareLinkSettings(event){
  this.linksEditors = false;
  this.contactEditor = false;
  if(this.shareLinkEditors == true){
    this.shareLinkEditors = false;
  }  else {
    this.shareLinkEditors = true;
  }
}

//links editor open...
linkSettings(event){
  this.shareLinkEditors = false;
  this.contactEditor = false;
  if(this.linksEditors == true){
    this.linksEditors = false;
  }  else {
    this.linksEditors = true;
  }
}

//contact links open...
contactLinkSettings(event){
  this.shareLinkEditors = false;
  this.linksEditors = false;
  if(this.contactEditor == true){
    this.contactEditor = false;
  }  else {
    this.contactEditor = true;
  }
}

// cancel editing
cancelEditing(){
  this.shareLinkEditors = false;
  this.linksEditors = false;
  this.contactEditor = false;
}
// to save social links.
saveSocialLinks(event){
  $('#shareLinkEditors').find('input').removeClass('error');
  $(event.target).attr('disabled','disabled').text('Saving....');
  var fb = $.trim($('#selectFacebookInp').val().toString());
  if(!this.is_url(fb) && fb != '') {
    $('#selectFacebookInp').addClass('error');
    $(event.target).removeAttr('disabled').text('Save');
    return false;
  }
  var twr = $.trim($('#selectTwitterInp').val().toString());
  if(!this.is_url(twr) && twr != '' ) {
    $('#selectTwitterInp').addClass('error');
    $(event.target).removeAttr('disabled').text('Save');
    return false;
  }
  var pint = $.trim($('#selectInstaInp').val().toString());
  if(!this.is_url(pint) && pint != ''){
    $('#selectInstaInp').addClass('error');
    $(event.target).removeAttr('disabled').text('Save');
    return false;
  }
  var insta = $.trim($('#selectPintrstInp').val().toString());
  if(!this.is_url(insta) && insta !='') {
    $('#selectPintrstInp').addClass('error');
    $(event.target).removeAttr('disabled').text('Save');
    return false;
  }
  var token =  localStorage.getItem('token');
  this.homepageService.updateShareLinks(token,fb,twr,pint,insta).subscribe(data => {
    this.updateWidgetContent(event.target);
  },(err) => {
    if(err.status !== 200){
      $('#selectFacebookInp').parents('.SocialIconsEdit').before('<sapn>Something went wrong. Try again.</span>');
      $(event.target).removeAttr('disabled').text('Save');
    }
  });
}

  removeLink(event){

      $(event.target).parents('.EditLinksFooter').remove();

    return false;
  }

  addLink($event){
    var html = $('#linksEditors').find('.EditLinksFooter:first').clone();
    html.find('input').val('');
    html.removeClass('hide');
    $('#linksEditors').find('.EditLinksFooter:last').after(html);
  }


  saveLinks(event){
    $(event.target).attr('disabled','disabled').text('Saving....');
    $('body').find('.linkErrorFooter').remove();
     let links : any[] = [];
     var thiss = this;
     var error = 0;
    $('#linksEditors').find('div.EditLinksFooter').each(function(){
      let link : object = {};
      if($.trim($(this).find('input[name="title"]').val().toString()) != ''  && $.trim($(this).find('input[name="url"]').val().toString()) != ''){
        link['caption'] = $(this).find('input[name="title"]').val();
        link['url'] = $(this).find('input[name="url"]').val();
        if(thiss.is_url(link['url']) == false || link['url'] == ''){
          error++;
          $(this).append('<small class="text-danger linkErrorFooter">Please enter valid url.</small>');
        }
        links.push(link);
      }
    });
    if(error > 0){
      $(event.target).removeAttr('disabled').text('Save');
      return false;
    }
    var token =  localStorage.getItem('token');
    this.homepageService.updateFooterLinks(token,links).subscribe(data => {
      this.updateWidgetContent(event.target);
    },(err) => {
          $('#linksEditors').find('.EditLinksFooter:first').before('<sapn>Something went wrong. Try again.</span>');
          $(event.target).removeAttr('disabled').text('Save');
    });
  }

  //This will show password to user in password field.
  showPassword(event){
    if($(event.target).parents('.form-group').find('i.fas').hasClass('fa-eye')){
      $(event.target).parents('.form-group').find('input').attr('type','password');
      $(event.target).parents('.form-group').find('i.fas').removeClass('fa-eye').addClass('fa-eye-slash').removeClass('active');
    } else {
      $(event.target).parents('.form-group').find('input').attr('type','text');
      $(event.target).parents('.form-group').find('i.fas').addClass('fa-eye').addClass('active').removeClass('fa-eye-slash');
    }

  }

  //This will save the contact information in footer.
  saveContact(event){
    var phone = $.trim($('input[name="contact_phone"]').val().toString());
    var email = $.trim($('input[name="contact_email"]').val().toString());
    if(!this.validateEmail(email) && email != ''){
      $('input[name="contact_email"]').addClass('error');
      return false;
    }
    var website = $.trim($('input[name="contact_website"]').val().toString());
    if(!this.is_url(website) && website != ''){
      $('input[name="contact_website"]').addClass('error');
      return false;
    }
    $(event.target).attr('disabled','disabled').text('Saving....');
    var token =  localStorage.getItem('token');
    this.homepageService.updateFooterContact(token,phone,email,website).subscribe(data => {
      this.updateWidgetContent(event.target);
    },(err) => {
      if(err.status !== 200){
       $('input[name="contact_phone"]').before('<sapn>Something went wrong. Try again.</span>');
        $(event.target).removeAttr('disabled').text('Save');
      }
    });

  }

  //this will update footer the widget content.
  updateWidgetContent(event) {
    this.homepageService.getConfig().subscribe((data) => {
      this.gloalSetting = data;
      this.shareLinkEditors = false;
      this.linksEditors = false;
      this.contactEditor = false;
      $(event).removeAttr('disabled').text('Save');
    })
  }

  //Function to verify if string is email or not, this will allow user to leave it blank.
  validateEmail(mail) {
    //checking for blank string too.
    if(mail.trim() == ''){
      return (false)
    }
    if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(mail)) {
      return (true)
    }
    return (false)
  }

  //Checking if url is https or not.
  is_url(str){
      if (/^(f|ht)tps?:\/\//.test(str)) {
        return true;
      } else {
        return false;
      }
  }

  //Sending request to server to update email and open confirmation modal.
  changeEmail(event){
    var email = $('#new-email').val();
    var token =  localStorage.getItem('token');
    var locationId = this.homepageService.getLocationId();
    if(email != ''){
      const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if(!re.test(String(email).toLowerCase())){
        $('#emailError').html('<span class="text-danger small">Please enter valid email.</span>');
        return false;
      }
      this.emailUpdateResMail = true;
    }else{
      $('#emailError').html('<span class="text-danger small">Please enter valid email.</span>');
      return false;
      //this.emailUpdateResMail = false;
    }
    this.updatingEmail = true;
    this.authService.updateEmail(email, locationId, token).subscribe(response => {
      //console.log(response, 'SCCCSSS');
      $('#closeChangeEmail').click();
      this.updatingEmail = false;
      this.emailUpdateRes = true;
    },(error) =>{
      //console.log(error, 'ERRRRR');
    });
  }

  //Confirmation modal has button to resend verification link.
  //this will send verification again.
  resendUpdateEmail(event){
    $(event.target).attr('disabled','disabled');
    var token =  localStorage.getItem('token');
    var locationId = this.homepageService.getLocationId();
    this.updatingEmail = true;
    this.authService.updateEmailResend(locationId, token).subscribe((response:any) => {
      this.updatingEmail = false;
      $('#messageSent').text(response.message);
    },(error) =>{
      //console.log(error, 'ERRRRR');
    });
  }

  //This will close email confirmation box.
  closeEmailRes(){
    this.emailUpdateRes = false;
    this.emailUpdateResMail = false;
  }

  getProfileDetail(access_token,locationId){
    this.authService.getProfileDetail(access_token,locationId).subscribe(profile => {

          this.patronLoggedIn = true;
          this.checkLogin = false;
          // this.cookieService.set( 'info', JSON.stringify({'token' : '','detail' :  profile.data }), 1,'/');
          var auth = localStorage.getItem('token');
          const profileData = profile.data;
          if (!profileData.patronNumber) {
            profileData.patronNumber = '998848';
          }
          this.firstName = profileData.firstName;
          // localStorage.setItem('info', JSON.stringify({'token' : auth, 'detail' :  profile.data }));
          localStorage.setItem('info', JSON.stringify({'token' : auth, 'detail' :  profileData }));
          this.cookieService.set( 'patron', 'true', 1,'/');
          this.cookieService.set( 'patronPermissions', JSON.stringify(profile.data.permission), 1,'/');
          // this.cookieService.set( 'userDetail', JSON.stringify({'patronId': profile.data.patronId,'firstName': profile.data.firstName,'lastName': profile.data.lastName, 'email': profile.data.email}), 1,'/');
          this.cookieService.set( 'userDetail', JSON.stringify({'patronId': profileData.patronId,'firstName': profileData.firstName,'lastName': profileData.lastName, 'email': profileData.email, 'patronNumber': profileData.patronNumber}), 1,'/');
          $('#login-modal').find('#closelogin').trigger('click');
          $('li#loginLi').removeClass('show').addClass('hide');
          if(profile.data.profilePicture != '') {
            $('li#profileLi').find('img').attr('src',profile.data.profilePicture).removeClass('hide').addClass('show');
          } else {
            $('li#profileLi').find('img').addClass('hide');
          }
          $('li#profileLi').find('span').text(profile.data.firstName).removeClass('hide').addClass('show');
          $('li#profileLi').addClass('show').removeClass('hide');
          // $('#Publish-My-List').addClass('show').removeClass('hide');
          $('li#myCollectionLi').addClass('show').removeClass('hide');
          if(profile.data.permission.opacAdmin){
            this.document.body.classList.add('login-patron');
          }
          localStorage.setItem('selectedResourcesIds', JSON.stringify(profile.data.personalListResourceIds));
          this.cookieService.set( 'MyLIstCount', profile.data.totalMyListCount, 1,'/');
          if(profile.data.totalMyListCount > 0 ){
            $('#Publish-My-List').removeClass('hide').addClass('show');
            $('a.onViewList').removeClass('hide').addClass('show');
          }
          $('#myCollectionLi').find('span.count').text(profile.data.totalMyListCount);
          this.homepageService.updateIsLogin(true);
          if(this.router.url.includes('/card')){
            // window.location.reload();
            this.homepageService.updateIsCardRoute(true);
          }else{
            setTimeout(() =>{
              this.router.navigate(['']);
            }, 500);
          }


        });
  }

  goToGoogleLogin(tenant, config){
    var tempUrl = 'https://googlelogin.library.site/';
    tempUrl += '?tenant='+tenant+'&config='+config;
    window.location.href=tempUrl;
  }

  private getMicrosoftSsoConfig(){
    if(
      this.gloalSetting &&
      this.gloalSetting.data &&
      this.gloalSetting.data.settings &&
      this.gloalSetting.data.settings.ssoLists &&
      Array.isArray(this.gloalSetting.data.settings.ssoLists)
    ){
      for (let index = 0; index < this.gloalSetting.data.settings.ssoLists.length; index++) {
        const ssoItem = this.gloalSetting.data.settings.ssoLists[index];
        const provider = ssoItem && (ssoItem.Provider || ssoItem.provider);
        if(
          ssoItem &&
          provider &&
          provider.toString().toLowerCase() === 'microsoftentra'
        ){
          return ssoItem;
        }
      }
    }
    return null;
  }

  isMicrosoftSsoEnabled(){
    const microsoftSsoConfig = this.getMicrosoftSsoConfig();
    const enabled = microsoftSsoConfig && (microsoftSsoConfig.Enabled || microsoftSsoConfig.enabled);
    if(typeof(enabled) === 'undefined'){
      return false;
    }
    return enabled === true || enabled === 'true';
  }

  getMicrosoftTenantId(){
    const microsoftSsoConfig = this.getMicrosoftSsoConfig();
    const tenantId = microsoftSsoConfig && (microsoftSsoConfig.TenantId || microsoftSsoConfig.tenantId);
    if(
      tenantId
    ){
      return tenantId;
    }
    return '';
  }

  private generateRandomString(length: number): string {
    const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let result = '';
    for (let index = 0; index < length; index++) {
      result += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    return result;
  }

  private base64UrlEncode(buffer: ArrayBuffer): string {
    const bytes = new Uint8Array(buffer);
    let binary = '';
    for (let index = 0; index < bytes.byteLength; index++) {
      binary += String.fromCharCode(bytes[index]);
    }
    return btoa(binary).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
  }

  private async generatePkceCodeChallenge(codeVerifier: string): Promise<string> {
    const encoded = new TextEncoder().encode(codeVerifier);
    const digest = await window.crypto.subtle.digest('SHA-256', encoded);
    return this.base64UrlEncode(digest);
  }

  async goToMicrosoftLogin(){
    if(!environment.microsoftSso || !environment.microsoftSso.clientId){
      this.notifier.notify('error', 'Microsoft SSO is not configured.');
      return;
    }
    if(!window.crypto || !window.crypto.subtle){
      this.notifier.notify('error', 'Microsoft login is not supported in this browser.');
      return;
    }
    const tenantId = this.getMicrosoftTenantId();
    const authorityBase = (environment.microsoftSso.authorityBaseUrl || 'https://login.microsoftonline.com').replace(/\/+$/, '');
    const authorityPath = tenantId ? `${tenantId}/oauth2/v2.0` : 'common/oauth2/v2.0';
    const authorizeUrl = `${authorityBase}/${authorityPath}/authorize`;
    const state = this.generateRandomString(32);
    const nonce = this.generateRandomString(32);
    const codeVerifier = this.generateRandomString(64);
    const codeChallenge = await this.generatePkceCodeChallenge(codeVerifier);
    localStorage.setItem('ms_sso_state', state);
    localStorage.setItem('ms_sso_nonce', nonce);
    localStorage.setItem('ms_sso_code_verifier', codeVerifier);

    const redirectUri = environment.microsoftSso.redirectUri || window.location.origin;
    localStorage.setItem('ms_sso_redirect_uri', redirectUri);
    const scope = environment.microsoftSso.scope || 'openid profile email';
    const params = new URLSearchParams({
      client_id: environment.microsoftSso.clientId,
      response_type: 'code',
      redirect_uri: redirectUri,
      response_mode: 'query',
      scope: scope,
      nonce: nonce,
      state: state,
      code_challenge: codeChallenge,
      code_challenge_method: 'S256',
      prompt: 'select_account'
    });

    window.location.href = `${authorizeUrl}?${params.toString()}`;
  }

  closeLogin(){
    this.requirePassword = false;
    $("#login-email").val('');
  }
}
